import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import { useFlags } from '@atlaskit/flag';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import { Subscriber } from '@atlaskit/rovo-triggers/main';
import { type Payload } from '@atlaskit/rovo-triggers/types';
import { token } from '@atlaskit/tokens';
import { logException } from '@atlassian/conversation-assistant-instrumentation/services/sentry';

import type { SolutionPlan } from '../types';

import { messages } from './messages';

export const SolutionPlanStateUpdateListener = ({
	refetch,
}: {
	refetch: () => Promise<SolutionPlan | null> | void;
}): React.JSX.Element => {
	di(Subscriber, useFlags);

	const { showFlag } = useFlags();
	const { formatMessage } = useIntl();

	const handlePubSubEvent = useCallback(
		async (payload: Payload) => {
			if (payload.type !== 'solution-plan-state-updated') {
				return;
			}

			try {
				await refetch();
			} catch (error) {
				logException({ exception: error, name: 'studio-plan-state-update-refetch-error' });

				showFlag({
					title: formatMessage(messages.solutionPlanStateUpdateErrorTitle),
					icon: <CrossCircleIcon color={token('color.icon.danger')} label="" />,
					description: formatMessage(messages.solutionPlanStateUpdateErrorDescription),
					isAutoDismiss: true,
				});
			}
		},
		[formatMessage, showFlag, refetch],
	);

	return <Subscriber topic="ai-mate" onEvent={handlePubSubEvent} />;
};
